<template>
  <div class="geofence-fields-airport">

    <div class="row margin-T">
      <div class="small-3 columns">
        <label class="checkbox-input">
          <input type="checkbox" v-model="geofence.trackEntryExit"
            @change="updateField('trackEntryExit')" />
          <span>TRACK ENTRY AND EXITS</span>
        </label>
      </div>
      <div class="small-3 columns">
        <label class="checkbox-input">
          <input type="checkbox" v-model="geofence.showInAppBanner"
            @change="updateField('showInAppBanner')" />
          <span>SHOW BANNER IN PROVIDER APP</span>
        </label>
      </div>
      <div class="small-3 columns">
        <label class="checkbox-input">
          <input type="checkbox" v-model="geofence.pushNotificationToProvUponEntry"
            @change="updateField('pushNotificationToProvUponEntry')" />
          <span>PUSH ENTRY NOTIFICATIONS</span>
        </label>
      </div>
      <div class="small-3 columns">
        <label class="checkbox-input">
          <input type="checkbox" v-model="geofence.hideProvidersInGeofence"
            @change="updateField('hideProvidersInGeofence')" />
          <span>HIDE PROVIDERS FROM CONSUMERS</span>
        </label>
      </div>
    </div>

    <div class="row margin-T">
      <div class="small-12 columns">
        <div class="input-field">
          <label>APPLICABLE SERVICE TYPES</label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="small-2 columns padding-R">
        <label class="checkbox-input">
          <input type="checkbox" v-model="checkService.shared" />
          <span>{{ serviceLabel('shared') }}</span>
        </label>
      </div>
      <div class="small-3 columns padding-L padding-R">
        <label class="checkbox-input">
          <input type="checkbox" v-model="checkService.opoli" />
          <span>{{ serviceLabel('opoli') }}</span>
        </label>
      </div>
      <div class="small-2 columns padding-L padding-R">
        <label class="checkbox-input">
          <input type="checkbox" v-model="checkService.black" />
          <span>{{ serviceLabel('black') }}</span>
        </label>
      </div>
      <div class="small-2 columns padding-L padding-R">
        <label class="checkbox-input">
          <input type="checkbox" v-model="checkService.suv" />
          <span>{{ serviceLabel('suv') }}</span>
        </label>
      </div>
      <div class="small-3 columns padding-L">
        <label class="checkbox-input">
          <input type="checkbox" v-model="checkService.shuttle" />
          <span>{{ serviceLabel('shuttle') }}</span>
        </label>
      </div>
    </div>

  </div>
</template>

<script>
import services from '@/modules/api/services'
// import stagingGeofenceAPI from '@/modules/api/geofences/staging'

export default {
  name: 'geofence-fields-restricted',
  props: [ 'geofence' ],
  data () {
    return {
      checkService: {
        shared: false,
        opoli: false,
        black: false,
        suv: false,
        shuttle: false
      }
    }
  },
  methods: {
    updateField (field) {
      this.$store.commit('geofences/setGeofenceField', {
        id: this.geofence.id,
        field: field,
        value: this.geofence[field] ? 1 : 0
      })
    },
    serviceLabel (code) { return services.getServiceName(code) }
  },
  watch: {
    geofence: function (value) {
      if (value) {
        if (!value.services) {
          this.checkService.shared = false
          this.checkService.opoli = false
          this.checkService.black = false
          this.checkService.suv = false
          this.checkService.shuttle = false
        } else {
          this.checkService.shared = value.services.shared ? value.services.shared.allowed : false
          this.checkService.opoli = value.services.opoli ? value.services.opoli.allowed : false
          this.checkService.black = value.services.black ? value.services.black.allowed : false
          this.checkService.suv = value.services.suv ? value.services.suv.allowed : false
          this.checkService.shuttle = value.services.shuttle ? value.services.shuttle.allowed : false
        }
      }
    },
    'checkService.shared': function (value) { this.geofence.services.shared.allowed = value },
    'checkService.opoli': function (value) { this.geofence.services.opoli.allowed = value },
    'checkService.black': function (value) { this.geofence.services.black.allowed = value },
    'checkService.suv': function (value) { this.geofence.services.suv.allowed = value },
    'checkService.shuttle': function (value) { this.geofence.services.shuttle.allowed = value }
  },
  mounted () {
    if (this.geofence.services) {
      this.checkService.shared = this.geofence.services.shared ? this.geofence.services.shared.allowed : false
      this.checkService.opoli = this.geofence.services.opoli ? this.geofence.services.opoli.allowed : false
      this.checkService.black = this.geofence.services.black ? this.geofence.services.black.allowed : false
      this.checkService.suv = this.geofence.services.suv ? this.geofence.services.suv.allowed : false
      this.checkService.shuttle = this.geofence.services.shuttle ? this.geofence.services.shuttle.allowed : false
    }
  }
}
</script>

<style lang="scss" scoped>
.input-field {
  font-size: 14px;

  & label {
    font-size: 12px;
    font-weight: 700;
    color: #0D79F2;
  }

  & input, & textarea {
    margin-top: 0;
    padding: 7px 10px;
  }

  & textarea {
    resize: none;
    height: 100px;
  }
}

.checkbox-input {
  & > * {
    display: inline-block;
    vertical-align: middle;
    width: auto;
  }
  & input {
    margin-top: 0;
  }
  & span {
    font-size: 12px;
    font-weight: 700;
    color: #777;
    height: 16px;
    margin-left: 3px;
    cursor: pointer;
  }
}

.padding-L { padding-left: 7px; }
.padding-R { padding-right: 7px; }
.margin-T { margin-top: 15px; }


@media only screen and (max-width: 430px) {
  .padding-R, .padding-L {
    padding: 0;
  }

  .small-2, .small-5, .small-6, .small-3, .small-4 , .small-8{
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Geofences/GeofenceFieldsRestricted.vue